export default "__VITE_ASSET__BppVoqIS__"